import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";
import {ConsolidatedBillingOrderService} from "../../services/consolidated-billing-order.service";
import {BillingOrdersDateRangeContext} from "../../services/billing-orders-date-range-context.service";
import {
  ExportConsolidatedBillingOrderTranslationsPayloadModel
} from "../../models/export-consolidated-billing-order-translations-payload.model";
import {
  ConsolidatedBillingOrderAddBillingOrdersPayloadModel
} from "../../models/consolidated-billing-order-add-billing-orders-payload.model";
import {
  ExportConsolidatedBillingOrdersTablePayloadModel
} from "../../models/export-consolidated-billing-orders-table-payload.model";
import {
  ExportConsolidatedBillingOrdersTableTranslationsPayloadModel
} from "../../models/export-consolidated-billing-orders-table-translations-payload.model";
import {ConsolidatedBillingOrderStatusType} from "../../types/consolidated-billing-order-status.type";
import {SortType} from "../../../commons/types/sort.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ConsolidatedBillingOrderDialogService} from "../../services/consolidated-billing-order-dialog.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BillingAccountDateType} from "../../types/billing-account-date.type";

export class ConsolidatedBillingOrdersViewCtrl implements IController {
  from: any;
  to: any;
  billingAccountId: string;
  billingAccountIds: any;
  selectedConsolidatedOrder: any;
  status: string;
  hasPrice: boolean;
  filterDateType: boolean;
  hasInvoiceError: boolean;
  dateRangeTemplateType: DateRangeTemplateType;

  public selectedIds: string[] = [];
  public excludeMode: boolean = false;
  public filtersConfig: any = {};
  public canCreateInvoice: boolean;
  public selectedOrder: any;
  public queryString: string;
  public selectedSortType: { name: string, type: SortType };
  public consolidatedBillingOrderStatusTypes: ConsolidatedBillingOrderStatusType[];
  public dateTypes: typeof BillingAccountDateType = BillingAccountDateType;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private splitService, private filePrinter, private viewFilterSettingsService: ViewFilterSettingsService,
              private $translate, private consolidatedBillingOrderService: ConsolidatedBillingOrderService, private billingAccountDialogService: BillingAccountDialogService,
              private billingOrdersDateRangeContext: BillingOrdersDateRangeContext, private consolidatedBillingOrderDialogService: ConsolidatedBillingOrderDialogService,
              private confirmDialogService: ConfirmDialogService) {
    this.consolidatedBillingOrderStatusTypes = Object.values(ConsolidatedBillingOrderStatusType);
  }

  $onInit() {
    this.filtersConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getBillingCustomTemplates(),
      filterDateType: this.filterDateType || BillingAccountDateType.CREATED_AT,
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {
          dateStart: this.from,
          dateEnd: this.to
        } : this.dateRangeTimeFiltersService.thisMonth()),
      billingAccountIds: this.billingAccountId ? [this.billingAccountId] : (this.billingAccountIds || []),
      status: this.status,
      hasPrice: this.hasPrice,
      hasInvoiceError: this.hasInvoiceError
    };
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortType && _.isEqual(this.selectedSortType.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortType.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortType = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc
    }
  }

  onRangeChanged(range) {

    this.filtersConfig.range = range;
    this.filtersConfig.range.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
    this.viewFilterSettingsService.setDateRangeTemplateType(this.filtersConfig.range.dateRangeTemplateType || undefined);

    this._setQueryParams();
  }

  onBillingAccountsChange(billingAccountIds) {
    this.filtersConfig.billingAccountIds = billingAccountIds;
    this.viewFilterSettingsService.setBillingAccountIds(billingAccountIds || []);
    this._setQueryParams();
  }

  onSelectedOrderStatus(status) {
    this.filtersConfig.status = status;
    this._setQueryParams();
  }

  onFilterDateTypeChange(filterDateType: BillingAccountDateType) {
    this.filtersConfig.filterDateType = filterDateType;
    this._setQueryParams();
  }

  onHasPriceStatusChange(hasPrice: boolean) {
    this.filtersConfig.hasPrice = !hasPrice;
    this._setQueryParams();
  }

  onHasInvoiceError(hasInvoiceError: boolean) {
    this.filtersConfig.hasInvoiceError = !hasInvoiceError;
    this._setQueryParams();
  }


  onBulkEditDate() {
    this.billingAccountDialogService.editConsolidatedBillingOrdersDate()
      .then((docDate) => {
        this._bulkUpdateDate(docDate);
      })
  }

  onSelectConsolidatedOrder(consolidatedOrder) {
    this.selectedConsolidatedOrder = consolidatedOrder;
    this._setQueryParams();
  }

  onSelectedIdsChange(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;
  }

  onBackToList() {
    this.selectedConsolidatedOrder = undefined;
    this._setQueryParams();
  }

  onEditConsolidatedBillingOrder(consolidatedBillingOrder) {
    this.billingAccountDialogService.editConsolidatedBillingOrder(consolidatedBillingOrder)
      .then((payload) => {
        this._updateConsolidatedBillingOrder(consolidatedBillingOrder.id, payload.name, payload.docDate, payload.comment, payload.billTo);
      })
  }

  onBulkExportPDF(event) {
    this.billingAccountDialogService.selectPdfTemplate(event, true)
      .then((payload: {pdfTemplate, includeEmptyPrices}) => {
        this._exportPDF(payload.pdfTemplate, undefined, payload.includeEmptyPrices);
      })
  }

  onExportPDF(consolidatedBillingOrder, event) {
    this.billingAccountDialogService.selectPdfTemplate(event, true)
      .then((payload: {pdfTemplate, includeEmptyPrices}) => {
        this._exportPDF(payload.pdfTemplate, consolidatedBillingOrder.id, payload.includeEmptyPrices);
      })
  }

  onExportCSV(consolidatedBillingOrder, includeEmptyPrices: boolean, event) {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedBillingOrderTranslationsPayloadModel = this._getExportPayload();
    this.consolidatedBillingOrderService.exportCSV(consolidatedBillingOrder.id, payload, includeEmptyPrices, zoneId);
  }

  onExportTable(event, exportType) {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedBillingOrdersTablePayloadModel = {
      exportType: exportType,
      zoneId: zoneId,
      fieldTranslationMap: this._getExportTablePayload()
    }

    if (this.excludeMode) {
      _.set(payload, 'from', this.filtersConfig.range.dateStart);
      _.set(payload, 'to', this.filtersConfig.range.dateEnd);
      _.set(payload, 'query', this.queryString);
      _.set(payload, 'filterDateType', this.filtersConfig.filterDateType);
      _.set(payload, 'excludeIds', this.selectedIds);
      _.set(payload, 'statuses', this.filtersConfig.status ? [this.filtersConfig.status] : undefined);
      _.set(payload, 'billingAccountIds', this.filtersConfig.billingAccountIds);
      _.set(payload, 'hasPrice', !!this.filtersConfig.hasPrice ? undefined : false);
      _.set(payload, 'isLastInvoicingFailed', this.filtersConfig.hasInvoiceError ? true : undefined);
    } else {
      _.set(payload, 'ids', this.selectedIds);
    }

    this.consolidatedBillingOrderService.exportTable(payload);
  }

  onPrint(consolidatedBillingOrder, event) {
    this.billingAccountDialogService.selectPdfTemplate(event, true)
      .then((payload: {pdfTemplate, includeEmptyPrices}) => {
        this._print(consolidatedBillingOrder, payload.pdfTemplate, payload.includeEmptyPrices);
      })
  }

  onCreateRefund(consolidatedBillingOrder, event) {
    this.billingAccountDialogService.refundConsolidatedBillingOrder(consolidatedBillingOrder)
      .then((payload) => {
        this._refundConsolidatedBillingOrder(consolidatedBillingOrder.id, payload.refundAmount, payload.comment, payload.dueDate);
      })
  }

  onAddBillingOrders(consolidatedBillingOrder, event) {
    this.billingAccountDialogService.addBillingOrdersToConsolidatedOrder(consolidatedBillingOrder.billingAccountId)
      .then((billingOrdersIdsToAdd) => {
        this._addBillingOrders(consolidatedBillingOrder, billingOrdersIdsToAdd);
      })
  }

  payManually(consolidatedBillingOrder, event) {
    this.consolidatedBillingOrderDialogService.payManually(consolidatedBillingOrder, event)
      .then((invoiceId: string) => {
        const payload = {
          invoiceId: invoiceId
        }
        this.consolidatedBillingOrderService.payManually(consolidatedBillingOrder.id, payload)
          .then(() => {
            this._refreshData();
          })
      })
  }

  resetPayManually(consolidatedBillingOrder, event) {
    this.confirmDialogService.confirm('Reset pay manually', 'Are you sure you want to reset the proforma?', event)
      .then(() => {
        this.consolidatedBillingOrderService.resetPayManually({proformaId: consolidatedBillingOrder.id})
          .then(() => {
            this._refreshData();
          })
      })
  }

  onDelete(consolidatedBillingOrder, event) {
    this.consolidatedBillingOrderService.removeBillingOrders(consolidatedBillingOrder.id, [], [], true)
      .then(() => {

        // Refresh Page
        this.filtersConfig = angular.copy(this.filtersConfig);
      })
  }

  private _bulkUpdateDate(docDate) {
    const payload = {
      docDate: docDate,
      billingAccountId: this.billingAccountIds
    }

    if (this.excludeMode) {
      _.set(payload, 'from', this.filtersConfig.range.dateStart);
      _.set(payload, 'to', this.filtersConfig.range.dateEnd);
      _.set(payload, 'query', this.queryString);
      _.set(payload, 'excludeIds', this.selectedIds);
      _.set(payload, 'hasPrice', !!this.filtersConfig.hasPrice ? undefined : false);
      _.set(payload, 'isLastInvoicingFailed', this.filtersConfig.hasInvoiceError ? true : undefined);
    } else {
      _.set(payload, 'ids', this.selectedIds);
    }

    this.consolidatedBillingOrderService.bulkEditDate(payload)
      .then(() => {
        this.selectedIds = [];
        this.excludeMode = false;
        this._refreshData();
      })
  }

  private _setQueryParams() {
    this.$state.go('.', {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      filterDateType: this.filtersConfig.filterDateType,
      consolidatedId: _.get(this.selectedConsolidatedOrder, 'id'),
      billingAccountIds: this.filtersConfig.billingAccountIds,
      status: this.filtersConfig.status,
      hasPrice: this.filtersConfig.hasPrice,
      hasInvoiceError: this.filtersConfig.hasInvoiceError
    }, {
      notify: false,
      reload: false
    })
  }

  private _updateConsolidatedBillingOrder(consolidatedId, name, docDate, comment, billTo) {
    this.consolidatedBillingOrderService.update(consolidatedId, name, docDate, comment, billTo)
      .then(() => {
        this._refreshData();
      })
  }

  private _addBillingOrders(consolidatedBillingOrder, billingOrdersIds) {
    const payload: ConsolidatedBillingOrderAddBillingOrdersPayloadModel = {
      addBillingOrderIds: billingOrdersIds,
      billingAccountId: consolidatedBillingOrder.billingAccountId
    }
    this.consolidatedBillingOrderService.addBillingOrders(consolidatedBillingOrder.id, payload)
      .then((updatedConsolidatedBillingOrder) => {

      })
  }

  private _refundConsolidatedBillingOrder(consolidatedId, refundAmount, comment, dueDate) {
    this.consolidatedBillingOrderService.refund(consolidatedId, refundAmount, comment, dueDate)
      .then(() => {
        // this._refreshData();
      })
  }

  private _exportPDF(proformaPdfTemplate, consolidatedBillingOrderId?, includeEmptyPrices?) {
    const zoneId = this.splitService.getTimeZone();
    const payload = {
      zoneId: zoneId,
      proformaPdfTemplate: proformaPdfTemplate,
      includeEmptyPrices: includeEmptyPrices,
      ids: consolidatedBillingOrderId ? [consolidatedBillingOrderId] : undefined
    }

    if (!consolidatedBillingOrderId) {
      if (this.excludeMode) {
        _.set(payload, 'billingAccountIds', this.filtersConfig.billingAccountIds);
        _.set(payload, 'filterDateType', this.filtersConfig.filterDateType);
        _.set(payload, 'statuses', this.filtersConfig.status ? [this.filtersConfig.status] : undefined);
        _.set(payload, 'from', this.filtersConfig.range.dateStart);
        _.set(payload, 'to', this.filtersConfig.range.dateEnd);
        _.set(payload, 'query', this.queryString);
        _.set(payload, 'excludeIds', this.selectedIds);
        _.set(payload, 'hasPrice', !!this.filtersConfig.hasPrice ? undefined : false);
        _.set(payload, 'isLastInvoicingFailed', this.filtersConfig.hasInvoiceError ? true : undefined);
      } else {
        _.set(payload, 'ids', this.selectedIds);
      }
    }

    this.consolidatedBillingOrderService.exportPDF(payload);
  }

  private _print(consolidatedBillingOrder, proformaPdfTemplate, includeEmptyPrices?: boolean) {
    const zoneId = this.splitService.getTimeZone();
    this.consolidatedBillingOrderService.getPDF(consolidatedBillingOrder.id, proformaPdfTemplate, includeEmptyPrices, zoneId)
      .then((res) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  private _getExportPayload(): ExportConsolidatedBillingOrderTranslationsPayloadModel {
    return {
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.createdAt'),
      completedAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.completedAt'),
      orderId: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.orderId'),
      origin: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.origin'),
      destination: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.destination'),
      packageName: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.packageName'),
      barcode: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.barcode'),
      referenceIds: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.referenceIds'),
      quantity: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.quantity'),
      packagePrice: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.packagePrice'),
      price: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.price')
    }
  }

  private _getExportTablePayload(): ExportConsolidatedBillingOrdersTableTranslationsPayloadModel {
    return {
      proformaName: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.proformaName'),
      proformaStatus: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.proformaStatus'),
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.createdAt'),
      updatedAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.updatedAt'),
      invoiceId: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.invoiceId'),
      docDate: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.docDate'),
      comment: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.comment'),
      billTo: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.billTo'),
      billingAccountName: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.billingAccountName'),
      orderQuantity: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.orderQuantity'),
      totalRefund: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.totalRefund'),
      totalPrice: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDERS_TABLE_COLUMNS.totalPrice')
    }
  }

  private _refreshData() {
    this.filtersConfig = angular.copy(this.filtersConfig);
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrdersView', {
    bindings: {
      from: '<?',
      to: '<?',
      billingAccountId: '<?',
      billingAccountIds: '<?',
      selectedConsolidatedOrder: '<?',
      status: '<?',
      hasPrice: '<?',
      filterDateType: '<?',
      hasInvoiceError: '<?',
      dateRangeTemplateType: '<?'
    },
    template: require('./consolidated-billing-orders-view.html').default,
    controller: ConsolidatedBillingOrdersViewCtrl
  });
